module.exports = ['$scope', '$state', '$q', 'services', 'employee', 'modal', 'coverageBuddy',
    function($scope, $state, $q, services, employee, modal, coverageBuddy) {

	$scope.selected = {};

    $scope.goToManageSPA = function() {
        if ($scope.selected.groupNumber && $scope.umi) {
            $state.go('assistEmployees.spendingAccounts',
				{
					groupNumber: $scope.selected.groupNumber,
					umi: $scope.umi
				}
			);
            modal.close();
        }
    };

	(function(allGroupNumbers) {
		allGroupNumbers =
			allGroupNumbers || coverageBuddy.getAllGroupNumbers(employee.data.subscriber);

		var spaPromises = allGroupNumbers.reduce(
			function(prev, next) {
				prev[next] = services.eprsvc.additionalGroupInformation({ 'groupNumber': next }).fetch(services.eprsvc.additionalGroupInformation().getEffectiveDate(next));
				return prev;
			},
			{}
		);


		$scope.viewstate = 'loading';

		$q.all(spaPromises).then(
			function(response){
				$scope.viewstate = 'success';

				$scope.groupNumbersWithSpending = Object.keys(response).map(
					function(groupNumber) {
						var spendingAccount =
							response[groupNumber] &&
							response[groupNumber].data &&
							response[groupNumber].data.payload &&
							response[groupNumber].data.payload.spendingAccount;

						return {
							groupNumber: groupNumber,
							spendingAccount: spendingAccount
						};
					}
				).filter(function(g) { return g.spendingAccount; }).map(function(g) { return g.groupNumber; });
			},
			function() { $scope.viewstate = 'error'; }
		);
	}( $scope.allGroupNumbers ));
}];

